import LegalLayout from "@/components/feature/LegalLayout";

/*
  HINWEIS (intern, vor Go-Live prüfen):
  - E-Mail-Domain vereinheitlichen: Impressum nennt elektro-zweering.de,
    Datenschutz nennt zweering-elektro.de. Bei Migration zu zweering.de
    konsolidieren.
  - Zwei Adressen (Firmensitz "An der Schleuse 10" vs. inhaltlich
    Verantwortlicher "Wassenbergstraße 44") — mit Bastian bestätigen.
*/

const sectionTitle =
  "font-bold uppercase text-[#0A0A0A] text-[20px] md:text-[24px] mt-12 mb-4 tracking-tight";

export default function Impressum() {
  return (
    <LegalLayout
      title="Impressum"
      metaTitle="Impressum | Zweering Elektrotechnik Emmerich am Rhein"
      metaDescription="Impressum der Zweering Elektrotechnik GmbH, An der Schleuse 10, 46446 Emmerich am Rhein — Angaben gemäß § 5 TMG."
      canonicalPath="/impressum"
    >

      <h2 className={sectionTitle}>Angaben gemäß § 5 TMG</h2>
      <p>
        Zweering Elektrotechnik GmbH<br />
        An der Schleuse 10<br />
        46446 Emmerich am Rhein<br />
        Deutschland
      </p>

      <h2 className={sectionTitle}>Kontakt</h2>
      <p>
        Telefon:{" "}
        <a href="tel:+492822791010" className="text-[#4CAF50] hover:underline">
          02822 791010
        </a>
        <br />
        Mobil:{" "}
        <a href="tel:+491724892149" className="text-[#4CAF50] hover:underline">
          0172 4892149
        </a>
        <br />
        E-Mail:{" "}
        <a
          href="mailto:info@elektro-zweering.de"
          className="text-[#4CAF50] hover:underline"
        >
          info@elektro-zweering.de
        </a>
      </p>

      <h2 className={sectionTitle}>Vertreten durch</h2>
      <p>Geschäftsführer: Bastian Zweering</p>

      <h2 className={sectionTitle}>Registereintrag</h2>
      <p>
        Eintragung im Handelsregister.<br />
        Registergericht: Amtsgericht Kleve<br />
        Registernummer: HRB 18815
      </p>

      <h2 className={sectionTitle}>Umsatzsteuer-ID</h2>
      <p>
        Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
        DE330635296
      </p>

      <h2 className={sectionTitle}>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
      <p>
        Bastian Zweering<br />
        Wassenbergstraße 44<br />
        46446 Emmerich am Rhein
      </p>

      <h2 className={sectionTitle}>Streitschlichtung</h2>
      <p>
        Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung
        (OS) bereit:{" "}
        <a
          href="https://ec.europa.eu/consumers/odr"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#4CAF50] hover:underline"
        >
          https://ec.europa.eu/consumers/odr
        </a>
        .
      </p>
      <p>
        Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor
        einer Verbraucherschlichtungsstelle teilzunehmen.
      </p>

      <h2 className={sectionTitle}>Haftung für Inhalte</h2>
      <p>
        Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf
        diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10
        TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte
        oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu
        forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
      </p>
      <p>
        Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen
        nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche
        Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten
        Rechtsverletzung möglich. Bei Bekanntwerden entsprechender Rechtsverletzungen
        werden wir diese Inhalte umgehend entfernen.
      </p>

      <h2 className={sectionTitle}>Haftung für Links</h2>
      <p>
        Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte
        wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch
        keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der
        jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten
        Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße
        überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht
        erkennbar.
      </p>
      <p>
        Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne
        konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei
        Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend
        entfernen.
      </p>

      <h2 className={sectionTitle}>Urheberrecht</h2>
      <p>
        Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten
        unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung,
        Verbreitung und jede Art der Verwertung außerhalb der Grenzen des
        Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors
        bzw. Erstellers.
      </p>
      <p>
        Downloads und Kopien dieser Seite sind nur für den privaten, nicht
        kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht
        vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet.
        Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie
        trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um
        einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen
        werden wir derartige Inhalte umgehend entfernen.
      </p>
    </LegalLayout>
  );
}
